import { useState, useEffect } from "react";
import IVPilot from "./IVPilot";
import LoadingScreen from "./LoadingScreen";

export default function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1800);
    return () => clearTimeout(t);
  }, []);
  if (loading) return <LoadingScreen />;
  return <IVPilot />;
}
